import { DateTime } from 'luxon';
import { ShiftSlot } from '../../types/shiftTypes.js';
import { getShiftEnd, getShiftSlotAt } from './shifts.js';

export interface ShiftSlotPeriod {
    start: Date;
    end: Date;
    shiftSlot: ShiftSlot;
}


export function divideIntoShiftSlots(start: Date, end: Date): ShiftSlotPeriod[] {
    if (!start || !end || start >= end) {
        return [];
    }

    const startLuxon = DateTime.fromJSDate(start).setZone('Europe/Helsinki');
    const endLuxon = DateTime.fromJSDate(end).setZone('Europe/Helsinki');

    const periods: ShiftSlotPeriod[] = [];
    let currentStartLuxon = startLuxon;
    while (true) {
        const shiftEndLuxon = getShiftEnd(currentStartLuxon);

        periods.push({
            start: currentStartLuxon.toJSDate(),
            end: minDate(shiftEndLuxon, endLuxon).toJSDate(),
            shiftSlot: getShiftSlotAt(currentStartLuxon),
        });

        if (shiftEndLuxon >= endLuxon) {
            break;
        } else {
            currentStartLuxon = shiftEndLuxon;
        }
    }
    return periods;
}

function minDate(a: DateTime, b: DateTime): DateTime {
    return a < b ? a : b;
}
